import React from 'react';

import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';
import { ColorFunction } from '@styles/colors/types';

export default ({ C, onClick, disabled, testID }: { C: ColorFunction; onClick: () => void; disabled?: boolean; testID?: string }) => {
  return (
    <Button
      {...{
        variant: 'Icon Button',
        type: 'Icon Button',
        onPress: onClick,
        disabled,
        testID,
      }}
    >
      <Svg
        icon="chevronRight"
        width={9}
        height={15}
        color={disabled ? 'Label/Light/Quinary' : 'Button/Light/Primary'}
        key={disabled ? 'disable-arrow' : 'active-arrow'}
      />
    </Button>
  );
};
